module.exports = {
  "tenantManager": {
    tenantManager: "租户管理",
    tenantName: "租户名称",
    tenantNameHint: "请输入租户名称",
    tenantList: "租户列表",
    contact: "联系人",
    contactHint: "请输入联系人",
    contactPhoneNumber: "联系人手机号",
    contactPhoneNumberHint: "请输入联系人手机号",
    contactPhoneNumberHint2: "请输入正确的联系人手机号",
    loginAccount: "登录账号",
    address: "地址",
    addressHint: "请选择地址",
    detailsAddress: "详细地址",
    detailsAddressHint: "请选择详细地址",
    organizationType: "租户类型",
    organizationTypeHint: "请选择租户类型",
    functionSettings: "功能设置",
    addSubItem: "新增子项",
    addTenant: "添加租户",
    editTenant: "编辑租户",
    tenantInfo: "租户信息",
    parentTenant: "上级租户",
    parentTenantHint: "请选择上级租户",
    tenantUserLimit: "用户人数上限",
    tenantUserLimitHint: "请输入用户人数上限",
    tenantLimit: "子租户上限",
    tenantLimitHint: "请输入子租户上限",
    "copyConnections": "复制链接",
    "copyConnectionsHint": "复制成功",
    packageSettings: "套餐设置",
  },
};


// WEBPACK FOOTER //
// ./src/i18n/tenantManager/zh-CN.js